import React, {useContext, useEffect, useState } from 'react';
import {SystemManager_API} from "../../SystemManager.API";
import {useParams} from "react-router-dom";
import {AuthContext} from "../../../../context/AuthContext";
import Page from "../../../../components/Pages/Page";
import BreadCrumbsItems from "../../../../components/Pages/BreadCrumbsItems/BreadCrumbsItems";
import { useAPI } from '../../../../hooks/useAPI'
import pencilSVG from '../../../../components/Pages/TablePage/Table/Cells/LinkCell3/pencil.svg'


function VerCanterMachines() {
    const {getMachines, saveMachine } = SystemManager_API.counterAgents.verificationCenter
    const {verCenterId,verCenterName} = useParams()
    const {REACT_APP_URL_PREFIX} = process.env
    const {token} = useContext(AuthContext)
	const { APIRequest } = useAPI()
	const [machines, setMachines] = useState([]);
	const [title, setTitle] = useState(verCenterName);
	const [modalVisible, setModalVisible] = useState(false);
	const [name, setName] = useState('');
	const [serialNumber, setSerialNumber] = useState('');
	const [isLaunched, setIsLaunched] = useState(false);
	const [price, setPrice] = useState('0');
	const [base, setBase] = useState('Машина');
	const [doza, setDoza] = useState('ЭЭД = 0,06млЗв');
	const [id, setId] = useState(0);
	const [machineStudyType, setMachineStudyType] = useState('Флюорография');

	useEffect(async () => {
		await loadData();
	}, []); // Pass empty array to only run once on mount.

	const breadCrumbsItems = [
        {title: 'Контрагенты'},
        {title: 'Удостоверяющие центры',  link: process.env.REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters`},
        {title: verCenterName},
        {title: 'Машины'},
    ]
	
	const loadData = async()=>{
		await APIRequest(getMachines(token.userId,verCenterId))
		.then(response => {
		  if (response.body) {
			  setMachines(response.body?.data);
		  }
		})
	}
	
	
	const saveMachineNow = async()=>{
		await APIRequest(saveMachine(token.userId,verCenterId,id), {
			name:name,
			serial_number:serialNumber,
			is_launched:isLaunched,
			price:price,
			base:base,
			doza:doza,
			machine_study_type:machineStudyType
		})
			.then(async(response) => {
			  if (response.body) {
				  alert(response.body?.message);
				  if (response.body?.message=='Ok') {
					  await loadData();
					  setModalVisible(false);
				  }
			  }
			})
	}

    return (
        <>
            <Page mobile={true}>
                <BreadCrumbsItems style={{left: '100px'}} routes={breadCrumbsItems}/>
				{ modalVisible ? 
					<div className="fade-in-fwd modal" onClick={()=>{setModalVisible(false)}}
						style={{left: 90, zIndex: 101}} >
						<div className="layer"
							style={{position: 'absolute', width: '100%', height: '100%'}}></div>
						<div className="formModal" ><div className="auth__form" onClick={(e)=>{e.stopPropagation();}}>
							<div className="closeButton" onClick={()=>{setModalVisible(false)}}>
								<i className="fas fa-times" style={{color: 'rgb(128, 189, 255)'}}></i>
							</div>
							<div className="formModal__title">Редактирование машины</div>
							<form className="auth__login-form auth__client__login-form" style={{maxHeight: 700}}>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="name">Название <span>*</span></label>
									<input id="name" className="form-input live-Search__input" 
										value={name} onChange={(event)=>{setName(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="serial_number">Код программы-загрузчика <span>*</span></label>
									<input id="serial_number" className="form-input live-Search__input" 
										value={serialNumber} onChange={(event)=>{setSerialNumber(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="is_launched">Онлайн чтение<span>*</span></label>
									<select id="is_launched" className="form-input live-Search__input" 
										onChange={(event)=>{setIsLaunched(event.target.value)}} 
										value={isLaunched}>
									   <option value="true">да</option>
									   <option value="false">нет</option>
								    </select>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="price">Цена хранения снимка, р <span>*</span></label>
									<input id="price" className="form-input live-Search__input" 
										value={price} onChange={(event)=>{setPrice(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="doza">Доза<span>*</span></label>
									<input id="doza" className="form-input live-Search__input" 
										value={doza} onChange={(event)=>{setDoza(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="base">Мобильность <span>*</span></label>
									<select id="base" className="form-input live-Search__input" 
										onChange={(event)=>{setBase(event.target.value)}} 
										value={base}>
									   <option value="Кабинет">Кабинет</option>
									   <option value="Машина">Машина</option>
								    </select>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="machine_study_type">Вид обследования <span>*</span></label>
									<select id="machine_study_type" className="form-input live-Search__input" 
										onChange={(event)=>{setMachineStudyType(event.target.value)}} 
										value={machineStudyType}>
									   <option value="Флюорография">Флюорография</option>
									   <option value="Рентген-очередь">Рентген</option>
									   <option value="Маммография-очередь">Маммография</option>
								    </select>
								</div></div>
								<div className="form-buttons"><button className="sign-in__button" onClick={(e)=>{
									e.preventDefault();
									saveMachineNow()
								}}>Сохранить</button></div>
							</form>
						</div></div>
					</div>
				: undefined}
				<div style={{paddingTop: 100, paddingLeft:30,paddingRight:30,paddingBottom:30}}>
					<div className="table" style={{left: 100}}><div className="table__content"><div className="wrapper">
					 <div className="table__row first-row">
					  <div className="cellWrapper"><div className="row__cell">Наименование</div></div>
					  <div className="cellWrapper"><div className="row__cell">Онлайн чтение</div></div>
					  <div className="cellWrapper"><div className="row__cell">Мобильность</div></div>
					  <div className="cellWrapper"><div className="row__cell">Вид обследования</div></div>
					  <div className="cellWrapper"><div className="row__cell">Действия</div></div>
					 </div>
					{machines.map(function(d, idx){
						 return (<div className="table__row" key={idx}>
							<div className="cellWrapper"><div className="row__cell">{d.name}</div></div>
							<div className="cellWrapper"><div className="row__cell">{d.is_launched ? 'да' : 'нет'}</div></div>
							<div className="cellWrapper"><div className="row__cell">{d.base}</div></div>
							<div className="cellWrapper"><div className="row__cell">{d.machine_study_type}</div></div>
							<div className="cellWrapper"><div className="row__cell">
								<div style={{height:25,width:25,cursor:'pointer'}} onClick={()=>{
									setId(d.id)
									setName(d.name)
									setIsLaunched(d.is_launched?'true':'false')
									setSerialNumber(d.serial_number)
									setPrice(d.price)
									setBase(d.base)
									setDoza(d.doza)
									setMachineStudyType(d.machine_study_type)
									setModalVisible(true)
								}}>
									<img src={pencilSVG} alt="open"/>
								</div>
							</div></div>
						 </div>)
				    })}
					</div></div>
					<div onClick={()=>{
						setId(0)
						setName('')
						setIsLaunched('false')
						setSerialNumber('')
						setPrice('5')
						setBase('Машина')
						setDoza('ЭЭД = 0,06млЗв')
						setMachineStudyType('Флюорография')
						setModalVisible(true)
					}} style={{position: 'absolute', bottom: 20, left: 20, cursor:'pointer',padding:10,
						borderColor:'#ccc',borderRadius: 10,borderWidth:1,borderStyle:'solid',}}>Добавить машину</div>
					</div>
				</div>
            </Page>
        </>
    );
}

export default VerCanterMachines;


